<div id="page-container">
  <div id="content-wrap">

    <div *ngIf="this.router.url!='/login' && this.router.url!='/admin-login' && this.router.url!='/login-sso'">
      <app-navbar></app-navbar>
    </div>

    <div class="container-fluid" style="padding-top: 1rem;">
      <router-outlet></router-outlet>
    </div>

  </div>
  <div class="footer-basic">
    <footer>
        <p class="copyright">
          <img src="../assets//img/2000px-Vodafone_icon.svg.png"
          alt="Vodafone"
          style="height: 30px;">
          Vodafone Group  © 2023
        </p>
    </footer>
  </div>
</div>




